/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskPriorityEnum } from './taskPriorityEnum';
import { TaskStatusEnum } from './taskStatusEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatchedTaskWrite { 
    readonly id?: number;
    subject?: number;
    title?: string;
    details?: string;
    status?: TaskStatusEnum;
    priority?: TaskPriorityEnum;
    patient?: string | null;
    appointment?: number | null;
    assignedToUser?: number | null;
    assignedToTeam?: number | null;
    dueDate?: string | null;
    readonly completedBy?: number | null;
    readonly completedAt?: string | null;
    readonly createdAt?: string | null;
}
export namespace PatchedTaskWrite {
}

export const PatchedTaskWrite_id_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_subject_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_title_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedTaskWrite_details_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_status_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_priority_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_patient_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_appointment_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_assignedToUser_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_assignedToTeam_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_dueDate_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_completedBy_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_completedAt_Validators: ValidatorFn[] =
    [ ];

export const PatchedTaskWrite_createdAt_Validators: ValidatorFn[] =
    [ ];


